<template>
	<div class="page-container">
		<!-- 简览视图 -->
		<div
			v-if="initialRenderState === 'overview'"
			class="overview-content"
			:class="{ 'overview-content--has-top-banner': isBannerFirst }"
			:style="{ 'min-height': deviceHeight }"
		>
			<div v-for="module in initialRenderModuleList" :key="module.moduleId" class="overview-module-wrapper">
				<SmartDisplayC
					:key="getModuleKey(module)"
					:compId="getModuleId(module)"
					mode="mob-overview"
					v-bind="getModuleProps(module)"
				/>
			</div>
			<SmartLayoutC compId="layout_footer" mode="mob-basic" />
		</div>

		<!-- 详情视图 -->
		<div v-else-if="initialRenderState === 'detail'" class="detail-content">
			<SmartDisplayC
				:compId="getModuleId(displayModule)"
				mode="mob-full"
				v-bind="getModuleProps(displayModule)"
			/>
		</div>

		<!-- 缺省兜底 -->
		<div v-else-if="initialRenderState === 'none'" class="default-content">
			<SurfContentEmpty />
		</div>
	</div>
</template>

<script setup>
import { ref } from 'vue';
import { useModuleAttrs } from '@rebuild/hooks/useModuleAttrs';
import SmartDisplayC from '@rebuild/components/SmartDisplayC.vue';
import SmartLayoutC from '@rebuild/components/SmartLayoutC.vue';
import { useDisplayLogic } from '@rebuild/materials/shared/page_container/useDisplayLogic';
import { get100vh } from '@/utils/api';
import SurfContentEmpty from '@rebuild/materials/shared/common/surf/SurfContentEmpty.vue';

const deviceHeight = ref(get100vh());
const { displayModuleList, displayModule, isOverview, isDetail, isBannerFirst } = useDisplayLogic();
const { getModuleKey, getModuleId, getModuleProps } = useModuleAttrs();

const initialRenderState = ref(null);
const initialRenderModuleList = ref([]);

const initInitialRender = () => {
	if (isOverview.value) {
		initialRenderState.value = 'overview';
		initialRenderModuleList.value = displayModuleList.value;
	} else if (isDetail.value) {
		initialRenderState.value = 'detail';
	} else {
		initialRenderState.value = 'none';
	}
};
initInitialRender();
</script>

<style lang="less" scoped>
.overview-module-wrapper {
	overflow: hidden;
}

.page-container {
	.overview-content {
		display: flex;
		flex-direction: column;
		gap: 64px;
		padding-top: 64px;

		&--has-top-banner {
			padding-top: 0;
		}
	}

	.detail-content {
		min-height: calc(100vh - var(--surf-mob-nav-height));
		padding-bottom: 26px;
	}
	.default-content {
		height: calc(100vh - var(--surf-mob-nav-height));
		display: flex;
		justify-content: center;
		align-items: center;
	}
}
</style>
